import { translations } from '../../../configs/translations'
import { useStore } from '../../../store/store'
import './Back.css'

export interface BackProps {
	onClick?: () => void
	containerStyles?: React.CSSProperties
	imgStyle?: React.CSSProperties
	text?: string
}

export const Back = ({ onClick, containerStyles, imgStyle, text }: BackProps) => {
	const language = useStore(state => state.language)
	const t = translations[language]

	return (
		<div
			className='back-button'
			onClick={() => {
				if (onClick) onClick()
			}}
			style={containerStyles}
		>
			<img src='/icons/24px/back-arrow.svg' alt='back' style={imgStyle} />
			<p>{text === undefined ? t.back : text}</p>
		</div>
	)
}
